
















import { Component, Prop, Vue } from 'vue-property-decorator'
import ErrorLayout from '@/views/shared/ErrorLayout.vue';

@Component({
    components: {
        'error-layout': ErrorLayout
    }
})
export default class Error extends Vue {
    @Prop() errorId!: string
}
